import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { showToast } from '../../../Common/Appcommon';
import requestApi from "../../../services/requestApi.service";
import { Formik } from 'formik';

const RCSBusinessSettings = () => {

    const [initialValues, setInitialValues] = useState({
        user_name: '',
        apikey: '',
        action: 'connect'
    });

    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        loadRCSDetails();
    }, []);

    const loadRCSDetails = async () => {
        setLoading(true);

        let params = {
            ENTITY: 'FORMPROCESS',
            OPERATION: 'RCS_AUTHORIZE_DETAILS'
        };

        let response = await requestApi.processServerRequest(params, 'web');

        if (response.issuccess && response.data) {
            setInitialValues({
                user_name: response.data[0] || '',
                apikey: response.data[1] || ''
            });

            if (response.data[0] && response.data[1]) {
                setIsAuthorized(true); // already connected
            }
        }

        setLoading(false);
    };
    const connectRCSEmbed = async (values, { setSubmitting }) => {
    let params = {
        ENTITY: 'FORMPROCESS',
        OPERATION: 'AUTHORIZE_RCS',
        action : values.action,
        user_name: values.user_name,
        apikey: values.apikey
    };

    let response = await requestApi.processServerRequest(params, 'web');

    if (response.issuccess) {
        if (values.action === 'disconnect') {
             setInitialValues({
                user_name:  '',
                apikey:  ''
            });
            showToast("RCS Disconnected Successfully.");
            setIsAuthorized(false);
        } else {
            showToast("Authorized Successfully.");
            setIsAuthorized(true);
        }
    }
    setSubmitting(false);
};


    const validate = (values) => {
        const errors = {};

        if (!values.user_name?.trim()) {
            errors.user_name = 'Username is required';
        }

        if (!values.apikey?.trim()) {
            errors.apikey = 'API Key is required';
        }

        return errors;
    };

    return (
        <div className="listview-container kv-main-wrapper h100per w-100">
            <div className="col-xl-12 col-lg-12 col-md-12 m-auto mt-2">
                <Container fluid>
                    <Card className="main-card border mb-3">
                        <CardHeader className="le-card-header">
                            RCS API SETTINGS
                        </CardHeader>

                        <CardBody>
                            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validate={validate}
                                onSubmit={connectRCSEmbed}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting
                                }) => (
                                    <Form onSubmit={handleSubmit}>

                                        {/* Username */}
                                        <FormGroup>
                                            <Label>User Name</Label>
                                            <Input
                                                type="text"
                                                name="user_name"
                                                value={values.user_name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                disabled={loading || isAuthorized}
                                                invalid={touched.user_name && !!errors.user_name}
                                            />
                                            <FormFeedback>{errors.user_name}</FormFeedback>
                                        </FormGroup>

                                        {/* API Key */}
                                        <FormGroup>
                                            <Label>API Key</Label>
                                            <Input
                                                type="password"
                                                name="apikey"
                                                value={values.apikey}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                disabled={loading || isAuthorized}
                                                invalid={touched.apikey && !!errors.apikey}
                                            />
                                            <FormFeedback>{errors.apikey}</FormFeedback>
                                        </FormGroup>

                                        {!isAuthorized && (
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                                disabled={isSubmitting || loading}
                                                onClick={() => (values.action = 'connect')}
                                            >
                                                {isSubmitting ? 'Connecting...' : 'Connect RCS'}
                                            </button>

                                        )}

                                        {isAuthorized && (
                                             
                                         <button
                                            type="submit"
                                            className="btn btn-danger"
                                            onClick={() => (values.action = 'disconnect')}
                                        >
                                            {isSubmitting ? 'Disconnecting...' : 'Disconnect RCS'}
                                        </button>

                                            
                                           
                                        )}

                                    </Form>
                                )}
                            </Formik>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </div>
    );
};

export default RCSBusinessSettings;
